import { Component, isDevMode,enableProdMode } from '@angular/core';
import { AuthenticationService } from './services/authentication/authentication.service';
import { Router } from '@angular/router';

enableProdMode();
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})

export class AppComponent {
    title = 'argon-dashboard-angular';

    public appPages = [];
    public usuarioLogado: any;
    app_loading = true;

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router
    ) {
        this.initializeApp();
    }

    ngOnInit() {
        if (isDevMode()) {
            console.log('👋 Development!');
        } else {
            console.log('💪 Production!');
        }
    }

    public errorMessage() {
        alert('teste');
    }

    logout() {
        this.authenticationService.logout();
        document.location.href = 'index.html';
    }

    initializeApp() {
        this.app_loading = this.authenticationService.loading;
        this.authenticationService.authenticationState.subscribe(state => {
            console.log('state', state);
            if (state) {
                this.usuarioLogado = this.authenticationService.usuario;
                this.router.navigate(['dashboard']);

            } else {
                if (!this.authenticationService.loading)
                    this.router.navigate(['login']);
            }
        });

    }


}
